import React, { useEffect, useState } from "react";
import "./entity.css";
import {
  Grid,
  Button,
  InputLabel,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
  Alert,
  Skeleton,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import instance from "../../ApiInstance/Inetrceptor";
import CancelIcon from "@mui/icons-material/Cancel";

const BaseCompany = () => {
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showmoreLoader, setShowmoreLoader] = useState(false);
  const [basevalue, setBasevalue] = useState({});
  const [isEditable, setIsEditable] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const GetBaseData = () => {
    setLoader(true);
    const body = {
      id: "",
      searchtext: "",
    };
    instance
      .post("api/v1/Master/Company/Get", body)
      .then((res) => {
        const newData = res?.data?.Value ?? [];
        console.log("newData", newData);
        setBasevalue(newData);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };

  const handleEdit = () => {
    setIsEditable(true);
  };

  const handleSave = () => {
    const name = basevalue[0].company_name.trim();
    const email = basevalue[0].company_email.trim();
    const password = basevalue[0].company_email_password.trim();

    if (!name || !email || !password) {
      setError("Please enter all the fields mandatory.");
      setTimeout(() => {
        setError(null);
      }, 5000);
    } else {
      const body = {
        company_id: 1,
        company_name: basevalue[0].company_name,
        company_email: basevalue[0].company_email,
        company_email_password: basevalue[0].company_email_password,
      };
      instance
        .post("api/v1/Master/Company/Post", body)
        .then((res) => {
          const newData = res?.data?.Value ?? [];
          setIsEditable(false);
          if (res?.data?.Success) {
            setError("");
            setSuccess(res?.data?.ResultMessage);
            setTimeout(() => {
              setSuccess(null);
            }, 5000);
          } else {
            setError(res?.data?.ResultMessage);
            setTimeout(() => {
              setError(null);
            }, 5000);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setLoader(false);
          setShowmoreLoader(false);
        });
    }
  };
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleChange = (event) => {
    const { id, value } = event.target;
    setBasevalue((prevBasevalue) => {
      const updatedBaseValue = [...prevBasevalue];
      updatedBaseValue[0] = {
        ...updatedBaseValue[0],
        [id]: value,
      };
      console.log("basevalue", updatedBaseValue);
      return updatedBaseValue;
    });
  };

  useEffect(() => {
    GetBaseData();
  }, []);
  return (
    <>
      <div className="parent_div">
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="mb-0"
        >
          <p className="heading_font">Base Company</p>
          <p className="head_div">
            
            
          </p>
        </div>

        <Grid container spacing={2} className="mb-5">
          <Grid item xs={12} lg={4}>
            <Typography
              variant="h7"
              className="font-color mb-1"
              style={{ fontWeight: "600" }}
            >
              Information about your base company{" "}
            </Typography>
          </Grid>
        </Grid>
        {error && (
          <Alert
            variant="outlined"
            severity="error"
            icon={<CancelIcon />}
            className="errorAlertbase mt-4"
          >
            {error}
          </Alert>
        )}
        {success && (
          <Alert
            variant="outlined"
            severity="success"
            className="sucessAlertbase mt-4"
          >
            {success}
          </Alert>
        )}
        {loader ? (
          <>
            {new Array(3).fill(3).map((element, index) => {
              return <Skeleton variant="rounded" width={"40%"} height={120} />;
            })}
          </>
        ) : (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={5}>
                <InputLabel htmlFor="company_name">Name{isEditable ? <span style={{color:"red"}}>*</span>:""}</InputLabel>
                <TextField
                  id="company_name"
                  size="small"
                  fullWidth
                  variant="outlined"
                  className="base_Textfield"
                  value={basevalue.length > 0 ? basevalue[0]?.company_name : ""}
                  onChange={handleChange}
                  disabled={!isEditable}
                  sx={{ border: "none", "& fieldset": { border: "none" } }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} className="mt-4">
              <Grid item xs={12} lg={5}>
                <InputLabel htmlFor="company_email">Company E-mail{isEditable ? <span style={{color:"red"}}>*</span>:""}</InputLabel>
                <TextField
                  id="company_email"
                  size="small"
                  fullWidth
                  className="base_Textfield"
                  value={
                    basevalue.length > 0 ? basevalue[0]?.company_email : ""
                  }
                  onChange={(event) => handleChange(event)}
                  disabled={!isEditable}
                  variant="outlined"
                  sx={{ border: "none", "& fieldset": { border: "none" } }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} className="mt-4">
              <Grid item xs={12} lg={5}>
                <InputLabel htmlFor="company_email_password">
                  Company E-mail password {isEditable ? <span style={{color:"red"}}>*</span>:""}
                </InputLabel>
                <TextField
                  id="company_email_password"
                  size="small"
                  fullWidth
                  variant="outlined"
                  className="base_Textfield"
                  type={showPassword ? "text" : "password"}
                  value={
                    basevalue.length > 0
                      ? basevalue[0]?.company_email_password
                      : ""
                  }
                  disabled={!isEditable}
                  onChange={(event) => handleChange(event)}
                  sx={{ border: "none", "& fieldset": { border: "none" } }}
                  InputProps={{
                    endAdornment: isEditable && (
                      <InputAdornment
                          position="end"
                          style={{ position: "absolute", right: 20 }}
                        >
                        <IconButton
                          onClick={handleClickShowPassword}
                          edge="end"
                        >
                          {isEditable && (
                            <>
                              {showPassword ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </>
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} className="mt-4">
              <Grid item xs={12} lg={5} sx={{ textAlign: "right" }}>
                {isEditable ? (
                  <Button
                    id="back-button"
                    variant="contained"
                    color="secondary"
                    onClick={handleSave}
                    sx={{ textTransform: "none" }}
                  >
                    Save Changes
                  </Button>
                ) : (
                  <button
                    id="back-button"
                    variant="contained"
                    className="edit_btn"
                    onClick={handleEdit}
                    sx={{ textTransform: "none" }}
                  >
                    Edit Details
                  </button>
                )}
              </Grid>
            </Grid>
          </>
        )}
      </div>
    </>
  );
};

export default BaseCompany;
